'use client';

import { DialogContent, DrawerContent } from '@shared/ui';
import { useMobile } from '@shared/hooks';

interface OtpContentProps {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export const OtpContent: React.FC<OtpContentProps> = ({
  children,
  className,
  dataTestId,
}) => {
  const isMobile = useMobile();

  const Content = isMobile ? DrawerContent : DialogContent;

  return (
    <Content
      data-testid={dataTestId}
      className={`max-h-max !min-h-[100px] px-0 ${className ?? ''}`}
    >
      {children}
    </Content>
  );
};
